<template>
  <div class="birthday-select "
       :class="{_error: error}">
    <div class="birthday-select__main">
      <BaseSelect :value="computedValue.day"
                  :options="days"
                  :label="labels ? $tGlobal('Day') : null"
                  @input="onInput('day', $event)"
                  @focus="$emit('focus')"
                  class="birthday-select__day"/>
      <BaseSelect :value="computedValue.month"
                  :options="months"
                  :label="labels ? $tGlobal('Month') : null"
                  @input="onInput('month', $event)"
                  @focus="$emit('focus')"
                  class="birthday-select__month"/>
      <BaseSelect :value="computedValue.year"
                  :options="years"
                  :label="labels ? $tGlobal('Year') : null"
                  @input="onInput('year', $event)"
                  @focus="$emit('focus')"
                  class="birthday-select__year"/>
    </div>
    <BaseInputError :value="error"/>
  </div>
</template>

<script>
  import {MONTHS} from '../constants/months'
  import BaseInputError from './BaseInputError'

  export default {
    components: {
      BaseInputError
    },
    props: {
      value: [Date, String, Number],
      error: [String, Array],
      labels: {
        type: Boolean,
        default: false
      },
      maxYear: {
        type: [String, Number],
        default: new Date().getFullYear() - 18,
      },
      minYear: {
        type: [String, Number],
        default: null,
      },
    },
    data() {
      return {
        innerValue: {
          year: null,
          month: null,
          day: null,
        }
      }
    },
    computed: {
      computedValue() {
        if (!this.value) {
          return this.innerValue
        }

        const time = new Date(this.value)

        return {
          year: time.getFullYear(),
          month: this.months[time.getMonth()],
          day: time.getDate(),
        }
      },
      years() {
        const currentYear = this.maxYear
        const lastYear = this.minYear || (currentYear - 100)
        const years = []
        for (let year = currentYear; year >= lastYear; year--) {
          years.push(year)
        }
        return years
      },
      months() {
        return MONTHS.map(item => this.$tMonth(item))
      },
      days() {
        const year = this.computedValue.year
        const month = this.computedValue.month

        const days = []
        let daysQuantity

        if (year && month) {
          const monthIndex = this.months.findIndex(m => m === month)
          daysQuantity = getDaysInMonth(year, monthIndex)
        } else {
          daysQuantity = 31
        }

        for (let day = 1; day <= daysQuantity; day++) {
          days.push(day)
        }

        return days
      }
    },
    methods: {
      onInput(key, value) {
        this.innerValue[key] = value
        const result = Object.assign(this.computedValue, {
          [key]: value
        })

        const year = result.year
        const month = result.month
        let day = result.day

        if (!year || !month || !day) return
        const monthIndex = this.months.findIndex(m => m === month)

        const daysQuantity = getDaysInMonth(year, monthIndex)
        if (day > daysQuantity) {
          this.innerValue['day'] = null

          if (this.value) {
            this.$emit('input', null)
          }

          return
        }

        let strMonthNum = (monthIndex + 1).toString().padStart(2, '0')
        let strDayNum = day.toString().padStart(2, '0')

        this.$emit('input', `${year}-${strMonthNum}-${strDayNum}`)
      }
    }
  }

  function getDaysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }
</script>

<style lang="less">

</style>
